module.exports = __webpack_public_path__ + "static/img/code.55d88d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/code.png
// module id = cMKc
// module chunks = 68